<template>
    <div>
        <h2>叉车端登录</h2>
        <van-form @submit="onSubmit">
            <van-field v-model="tel" name="tel" maxlength="11" type="tel" label="手机号" placeholder="手机号"/>
            <van-field v-model="password" name="password" type="password" label="密码"/>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Dialog, Form} from 'vant';

    Vue.use(Form);

    export default {
        data() {
            return {
                tel: '',
                password: '',
            };
        },
        methods: {
            onSubmit(values) {
                localStorage.setItem('tel', this.tel);
                localStorage.setItem('password', this.password);
                let querystring = require("querystring");
                this.$api.post("wx/box-manage/login",
                    querystring.stringify({
                        tel: values.tel,
                        password: values.password,
                    })
                ).then(({data}) => {
                    if (data.status == 1) {
                        localStorage.setItem('id', data.data.id);
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {
                            this.$router.push({path: "/box-manage/home"});
                        });
                    } else {
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {
                        });
                    }
                });
            },
        },
        mounted() {
            this.tel = localStorage.getItem('tel');
            this.password = localStorage.getItem('password');
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/box-manage/login.vue